<template>
  <navbar>
    <button class="navbar-toggler mobile-sidebar-toggler d-lg-none" type="button" @click="mobileSidebarToggle">&#9776;</button>
    <a class="navbar-brand" href="/"></a>
    <ul class="nav navbar-nav d-md-down-none">
      <li class="nav-item">
        <a class="nav-link navbar-toggler sidebar-toggler" href="#" @click="sidebarMinimize">&#9776;</a>
      </li>

    </ul>
    <ul class="nav navbar-nav ml-auto header">
      <!--<dropdown class="lang-dropdown">
        <img v-if="$i18n.locale == 'en'" slot="button" src="/static/img/blank.gif" class="flag flag-us"/>
        <img v-if="$i18n.locale == 'th'" slot="button" src="/static/img/blank.gif" class="flag flag-th"/>
        <ul slot="dropdown-menu" class="dropdown-menu">
          <li><a @click="changeLang('th')"><img src="/static/img/blank.gif" class="flag flag-th" alt="Thai" /> ไทย</a></li>
          <li><a @click="changeLang('en')"><img src="/static/img/blank.gif" class="flag flag-us" alt="English" /> English</a></li>
        </ul>
      </dropdown>-->
      <dropdown size="nav" class="nav-item nav-profile">
        <span slot="button">
          <i class="fa fa-user fa-lg"></i>
          <span class="d-md-down-none">{{userName}}</span>
        </span>
        <div slot="dropdown-menu" class="dropdown-menu dropdown-menu-right">
          <div class="dropdown-header text-center" v-if="$guser.isClinicMulti()"><strong>Clinics</strong></div>
          <a v-if="$guser.isClinicMulti()" class="dropdown-item" :href="'/clinic/general?ref_clinic_id='+clinic.id" v-for="(clinic, index) in $guser.user.clinics" :key="index">
            <i class="fa fa-hospital-o"></i> {{clinic.clinic_name}}
          </a>
          <div class="dropdown-header text-center"><strong>Others</strong></div>
          <div class="divider"></div>
          <a class="dropdown-item" :href="'/clinic_multi'" v-if="$guser.isClinicMulti()">
            <i class="fa fa-hospital-o"></i> หน้าแรก
          </a>
          <router-link class="dropdown-item" :to="'/package/me'"><i class="fa fa-info-circle" aria-hidden="true"></i> {{$t('message.menu.my_subcription')}}</router-link>
          <a class="dropdown-item" href="#" @click='signout'><i class="fa fa-lock"></i> {{$t('message.menu.sign_out')}}</a>
        </div>
      </dropdown>

    </ul>
  </navbar>
</template>
<script>

import navbar from './Navbar'
import { dropdown } from 'vue-strap'

export default {
  name: 'header',
  components: {
    navbar,
    dropdown
  },
  computed: {
    userName () {
      if (this.$guser.isClinic(this.$route)) {
        return this.$guser.user.name
      }
      if (this.$guser.isDoctor()) {
        return `${this.$guser.user.doctor.firstname} ${this.$guser.user.doctor.lastname}`
      }
      return 'admin'
    }
  },
  methods: {
    click () {
      // do nothing
    },
    sidebarToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-hidden')
    },
    sidebarMinimize (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-minimized')
    },
    mobileSidebarToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-mobile-show')
    },
    asideToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('aside-menu-hidden')
    },
    async signout () {
      await this.$guser.signout()
      this.$router.push('/auth/login')
    },
    changeLang (lang) {
      this.$ls.set('lang', lang)
      this.$i18n.locale = lang
    }
  }
}
</script>
<style lang="less">
.nav-profile{
  padding-right: 10px;
}

.flag {
  margin-left: 10px;
}

.lang-dropdown {
  margin-right: 15px;
}
.header{
  .dropdown-item.active{
    color: #263238;
    text-decoration: none;
    background-color: transparent;
  }
}

</style>



// WEBPACK FOOTER //
// Header.vue?72be11b0